import React,{useState, useEffect} from 'react';

const UseGeoLoaction = () => {

    const [location, setLocation] = useState({
        loaded: false,
        coordinates: {lat: '', lng: ''}
    });
    

    const onSuccess = (location) => {
        console.log("Current position:", location.coords.latitude, location.coords.longitude);
        setLocation ({
            loaded : true,
            coordinates : {
                lat : location.coords.latitude,
                lng : location.coords.longitude,
            },
        });

    };


    const onError = (error) => {
        console.warn("Geolocation error:", error.code, error.message);
        setLocation ({
            loaded : true,
            error:{
                code:error.code,
                message:error.message
            }
        });
    };

    useEffect(() => {
        if(!("geolocation" in navigator)) {
            console.error("Geolocation not supported in this browser");
            onError ({
                code : 0,
                message : 'Geo location not supported' 
            });
            
        }
       // navigator.geolocation.getCurrentPosition(onSuccess, onError);
       // Ask for permission + get position
       const watcher =  navigator.geolocation.getCurrentPosition(onSuccess, onError, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
        });
       // return () => watcher && navigator.geolocation.clearWatch(watcher);
    }, [])

    
    return location;


}
export default UseGeoLoaction;